import html2pdf from 'html2pdf.js'

export function exportHtml() {
  const element = document.getElementById('task-based-on')
  if (!element) {
    console.error('No top-level based-on found')
    return
  }
  const filename = prompt("Enter file name") ?? undefined
  const width = element.offsetWidth + 30
  return html2pdf().set({filename, html2canvas: {width, scale: 2}}).from(element).save()
}
